export function oneOneOneNotificationDataInjector(bookedEventNotification) {
  const sourceId = bookedEventNotification.sourceId
  const variablesForUse = bookedEventNotification.variablesForUse

  bookedEventNotification.setOnClick((notificationDataFromComponent) => {
    variablesForUse.navigate(`my-live-sessions/booked-sessions/${sourceId}`)
  })
}
